var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-sf-toolbar" }, [
    _c("div", { staticClass: "c-sf-toolbar__nav" }, [_vm._t("breadcrumb")], 2),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "c-sf-toolbar__search" },
      [
        _c("SearchIcon", {
          staticClass: "c-sf-toolbar__search-icon",
          attrs: { width: 16, height: 16 },
        }),
        _vm._v(" "),
        _c("input", {
          staticClass: "form-control",
          attrs: { type: "text", placeholder: _vm.placeholder },
          domProps: { value: _vm.value },
          on: {
            input: function ($event) {
              return _vm.$emit("input", $event.target.value)
            },
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.$emit("search")
            },
          },
        }),
        _vm._v(" "),
        _vm.value
          ? _c(
              "button",
              {
                staticClass: "c-sf-toolbar__clear",
                attrs: { type: "button", title: "Clear search" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("clear")
                  },
                },
              },
              [_c("XIcon", { attrs: { width: 14, height: 14 } })],
              1
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.showCreateFolder
      ? _c(
          "button",
          {
            staticClass: "c-sf-toolbar__icon",
            attrs: { type: "button", title: "New folder" },
            on: {
              click: function ($event) {
                return _vm.$emit("create-folder")
              },
            },
          },
          [_c("FolderPlusIcon", { attrs: { width: 16, height: 16 } })],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showFavorites
      ? _c(
          "button",
          {
            staticClass: "c-sf-toolbar__icon",
            class: { "is-active": _vm.favoritesActive },
            attrs: {
              type: "button",
              title: _vm.favoritesActive
                ? "Show all folders"
                : "Show favorites only",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-favorites")
              },
            },
          },
          [_c("BookmarkIcon", { attrs: { width: 16, height: 16 } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }